import { Reveal, ChapterTag } from "@/components/Reveal";

export const About = () => (
  <section id="about" data-testid="about-section" className="bg-slateDark px-5 py-20 sm:px-8 sm:py-28 lg:px-16 lg:py-36">
    <div className="mx-auto max-w-4xl">
      <Reveal className="text-center">
        <ChapterTag index="08" label="About Nivaan" />
      </Reveal>
      <Reveal delay={0.1} className="mt-10 text-center">
        <h2 className="font-serif text-4xl font-light leading-tight tracking-tight text-zinc-50 sm:text-5xl">
          Built With a <span className="italic text-gold-gradient">Simple Belief.</span>
        </h2>
      </Reveal>
      <Reveal delay={0.2}>
        <div className="mx-auto mt-10 max-w-2xl space-y-5 text-center text-base font-light leading-relaxed text-zinc-400 sm:text-lg">
          <p>
            Nivaan Experiences exists on a simple belief: travel should give you memories,
            not another list of things to manage.
          </p>
          <p>
            We focus on creating personalized journeys around each traveler's preferences, schedule and budget.
          </p>
          <p>We're starting small, personally managing our early journeys and learning from every customer.</p>
          <p>
            Our goal is simple — to create journeys memorable enough that our customers choose Nivaan again
            and recommend us to the people they care about.
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);
